<template>
  <div class="unitInfo">
    <div class="unitInfoConter">
      <div class="businessCard">
        <div class="businessCardText">
          <h1>Dear customer</h1>
          <p>I'm delighted to share {{unitData.projectName}}-{{unitData.unitName}} with you. Please don't hesitate to contact me for a viewing or if you have any questions - thank you!</p>
        </div>
        <div class="linkman">
          <div class="linkmanLf">
            <span class="linkmanLfImg" :style="{backgroundImage: 'url(' + img_url+agentData.logo + ')'}"></span>
            <div class="text">
              <h5>{{agentData.agentName}}</h5>
              <p>{{agentData.brokeName}}</p>
              <p v-if="!agentData.signature">CEA: {{agentData.regNum}}</p>
              <h6 v-if="!agentData.signature">Mobile: {{agentData.mobile}}</h6>
              <p v-if="!agentData.signature">Email: {{agentData.email}}</p>
              <p v-if="agentData.signature" v-html="agentData.signature"></p>
            </div>
          </div>
          <div class="linkmanRt">
            <img :src="img_url + agentData.brokeLogo" alt />
          </div>
        </div>
        <div class="callBtns">
          <a :href="`tel:${agentData.mobile}`">CALL</a>
          <a :href="`sms:${agentData.mobile}`">SMS</a>
          <a target="_blank" :href="`https://wa.me/${whatsapp}`">WHATSAPP</a>
        </div>
        <div class="shareBtns">
          <a :href="`${href}/${projectName}/${agentData.regNum}`" target="_blank" rel="noopener noreferrer">Click Here For Project Information</a>
          <!-- <a :href="`https://app.singmap.com/share/index.html#/infoPage?projectId=${unitInfo.projectId}&agentId=${unitInfo.agentId}&single=yes&keyword=${unitInfo.keyword}`" target="_blank" rel="noopener noreferrer">Click Here For Project Information</a> -->
        </div>
      </div>
      <div class="logoDom">
        <p>{{unitData.projectName}}-{{unitData.unitName}}</p>
      </div>
      <div class="unitDiv">

        <img class="unitBg" ref="planImg" :src="img_url + imgData+watermark" alt />
        <div class="unitTab">
          <ul>
            <li class="unitTabLi" v-for="(item,index) in unitData.lists" :key="index">
              <span class="unitTabLi-lf">{{item.key}}</span>
              <span class="unitTabLi-rt">{{item.value}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      unitInfo: {},
      img_url: '',
      unitData: {},
      agentData: {},
      imgData: '',
      href: '',
      projectName: "",
      watermark: ''
    }
  },
  computed: {
    whatsapp () {
      let num = ''
      if (this.agentData.mobile) {
        num = parseFloat(this.agentData.mobile.replace(/[^0-9]/gi, ''))
      }
      return num
    },
  },
  mounted () {
    console.log('unitInfo')
    this.getShareParams()
    console.log(location.origin)
    this.href = location.origin
  },
  methods: {
    getShareParams () {
      let param = this.$route.params
      console.log(param.projectName)
      this.projectName = param.projectName
      console.log(param)
      this.$Post(this.$api.getShareParams, param)
        .then(res => {
          if (res.code === '0') {
            this.unitInfo = res.datas
            this.querySysConfig()
            this.GetUnitFn()
            this.getEmailSetting()
          }
        })
    },
    GetUnitFn () {
      this.$Get(this.$api.getUnitInfo, {
        ...this.unitInfo,
        source: 'share',
      }).then((res) => {
        if (res.code == 0) {
          console.log(res.datas.projectName)
          // this.unitData = res.datas;
          this.imgData = res.datas.img
          if (res.datas.img) {
            this.$nextTick(() => {
              let self = this
              this.$refs.planImg.onload = function () {
                self.unitData = res.datas
              }
            })
          } else {
            this.unitData = res.datas
          }
        }
      })
    },
    getEmailSetting () {
      let self = this
      this.$Get(this.$api.getEmailSetting, {
        agentId: self.unitInfo.agentId,
      }).then((res) => {
        if (res.code == 0) {
          this.agentData = res.datas

        }
      })
    },
    querySysConfig () {
      this.$Get(this.$api.querySysConfig, {}).then((res) => {
        if (res.code == 0) {
          this.img_url = res.datas.img_url
          this.watermark = res.datas.oss_img_resize
        }
      })
    },
  },
}
</script>

<style lang="less">
.unitInfo {
  background-color: #f4f4f4;
  // padding: 20px 0;
  height: 100%;
  box-sizing: border-box;
  // overflow-y: scroll;
  position: relative;
  .unitInfoConter {
    border-radius: 20px;
    background-color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    overflow-y: scroll;
    .businessCard {
      // height: 300px;
      // border-radius: 20px;
      background: #fff;
      margin-bottom: 20px;
      padding: 15px;
      h1,
      p {
        margin: 0;
        margin-bottom: 15px;
        font-size: 14px;
      }
      h1 {
        font-size: 15px;
      }
      .businessCardText {
        border-bottom: 1px solid #f4f4f4;
      }
      .linkman {
        display: flex;
        padding-top: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid #f4f4f4;
        div {
          position: relative;
        }
        .linkmanLf {
          width: 60%;
          padding-left: 60px;
          .linkmanLfImg {
            position: absolute;
            width: 50px;
            height: 50px;
            left: 0;
            top: 50%;
            margin-top: -25px;
            border-radius: 50%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 0 0;
          }
          .text {
            h5,
            h6,
            p {
              margin: 0;
              margin-bottom: 10px;
            }
          }
        }
        .linkmanRt {
          width: 40%;
          display: flex;
          align-items: center; /*定义body的元素垂直居中*/
          justify-content: center; /*定义body的里的元素水平居中*/
          img {
            max-width: 100%;
          }
        }
      }
      .callBtns {
        padding-top: 15px;
        text-align: center;
        a {
          width: 20%;
          text-align: center;
          margin-right: 5%;
          display: inline-block;
          border: 1px solid #f05e5e;
          border-radius: 5px;
          padding: 5px;
          font-size: 12px;
          color: #f05e5e;
          text-decoration: none;
        }
        a:last-child {
          margin-right: 0;
        }
        a:active {
          background: #ddd;
          border-color: #fff;
        }
      }
      .shareBtns {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        a {
          border: 1px solid #f05e5e;
          color: #f05e5e;
          padding: 5px;
          margin: 0 10%;
          display: block;
          border-radius: 5px;
        }
      }
    }
    .logoDom {
      padding: 20px 0;
      text-align: center;
      img {
        max-width: 100%;
        height: 40px;
      }
      span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 2.5vh;
        font-weight: 600;
        padding-left: 40px;
        position: relative;
        // background-image: url("../assets/img/logo.png");
        // background-position: 0 0;
        // background-repeat: no-repeat;
        // background-size: 30px 30px;
        img {
          position: absolute;
          left: 0;
          top: 0;
          height: 30px;
          width: 30px;
        }
      }
    }
    .unitDiv {
      .unitBg {
        // padding-bottom: 60%;
        // background-position: 0 0;
        // background-repeat: no-repeat;
        // background-size: cover;
        width: 100%;
      }
      .unitTab {
        ul {
          list-style: none;
          padding: 10px;
          margin: 0;
          .unitTabLi {
            overflow: hidden;
            border-bottom: 1px solid #ddd;
            .unitTabLi-lf {
              float: left;
              height: 40px;
              line-height: 40px;
              width: 30%;
            }
            .unitTabLi-rt {
              float: right;
              height: 40px;
              width: 70%;
              line-height: 40px;
            }
          }
          // .unitTabLi:la
        }
      }
    }
  }
  .contactsCard {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    background: #fff;
    border-top: 1px solid #f4f4f4;
    .contactsCardLf {
      width: 50%;
      position: relative;
      padding-left: 75px;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        position: absolute;
        left: 15px;
        top: 50%;
        margin-top: -25px;
      }
      .contactsCardLfText {
        height: 80px;
        h3 {
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 40px;
          line-height: 48px;
        }
        p {
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 40px;
          // line-height: 40px;
        }
      }
    }
    .contactsCardRf {
      width: 50%;
      text-align: center;
      span {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-top: 20px;
        a {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .phone {
        background: url("../assets/img/phone.png") no-repeat 0 0;
        background-size: 100% 100%;
        margin-right: 15px;
      }
      .note {
        background: url("../assets/img/note.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/unitInfo.vue